module.exports = __webpack_public_path__ + "media/images/flags/ES-14afeef089c91b30989a8b8c5a50a95c.svg";